import { Controller, Control, Path, FieldValues } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

interface SelectFieldProps<
  O extends { id: string | number; name: string },
  TField extends FieldValues
> {
  control: Control<TField>;
  name: Path<TField>;
  options: O[];
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  disableClearable?: boolean;
  backgroundColor?: string;
  id?: string;
  fullWidth?: boolean | false;
}

export const SelectField = <
  O extends { id: string | number; name: string },
  TField extends FieldValues
>(
  props: SelectFieldProps<O, TField>
) => {
  const {
    control,
    options,
    name,
    disableClearable,
    disabled,
    backgroundColor,
    fullWidth,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { onChange, value, ref } = field;
        return (
          <>
            <Autocomplete
              disableClearable={disableClearable}
              id={props.id}
              fullWidth={fullWidth}
              value={
                value !== undefined && value !== null && value !== ""
                  ? options.find((option) => {
                      return String(value) === String(option.id);
                    }) ?? null
                  : null
              }
              disabled={disabled}
              getOptionLabel={(option) => {
                return option.name;
              }}
              onChange={(event: any, newValue) => {
                onChange(newValue != null ? newValue.id : null);
              }}
              options={options}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={!!error}
                  sx={{ backgroundColor: backgroundColor }}
                  helperText={error ? error.message : ""}
                  placeholder={props.placeholder}
                  label={props.label}
                  variant="outlined"
                />
              )}
            />
          </>
        );
      }}
    />
  );
};
